import { getBrandStorage } from './getBrand';

export const getLogos = (type) => {
  const logos = require.context('../assets/logos', true);
  const loadImage = (imageName) => logos(`./${imageName}`);

  return loadImage(`${getBrandStorage()}-${type}.png`).default;
};
